import { HelperState } from 'sierra-client/views/course-helper/types'

export function isSecondaryHelperStyling(helperState: HelperState): boolean {
  return helperState.type === 'text' && helperState.textType !== 'continue'
}
